<div class="mainpanel">
    <h2 class="mat-title">Judge Tools for Development Only</h2>
    <p>
        Run the processes below to set the judging to various states for training and testing purposes.
        All of the below will clear all nominations/judges for the selected nomination.
    </p>
    <div class="jobs">
        <div class="tool mat-elevation-z10" fxLayout="row" fxLayoutAlign="space-between center">
            <div>
                <h2>Clear Nominations and Judges</h2>
                <p>This will clear all nominations and judges. This is helpful to get a clean slate.</p>
            </div>
            <button mat-raised-button color="primary" (click)="JudgeTool(1)">Run Process</button>
        </div>
        <div class="tool mat-elevation-z10" fxLayout="row" fxLayoutAlign="space-between center">
            <div>
                <h2>Set Nominees</h2>
                <p>All of the previous plus it will create random nominees across all board districts. This is helpful to show how to complete nomination forms.</p>
            </div>
            <button mat-raised-button color="primary" (click)="JudgeTool(2)">Run Process</button>
        </div>
        <div class="tool mat-elevation-z10" fxLayout="row" fxLayoutAlign="space-between center">
            <div>
                <h2>Complete Nomination Forms</h2>
                <p>All of the previous plus input generic responses to their nomination forms. This is helpful to show how to assign judges.</p>
            </div>
            <button mat-raised-button color="primary" (click)="JudgeTool(3)">Run Process</button>
        </div>
        <div class="tool mat-elevation-z10" fxLayout="row" fxLayoutAlign="space-between center">
            <div>
                <h2>Set Judges</h2>
                <p>All of the previous plus assign random judges. This is helpful to show judges how to score nominees.</p>
            </div>
            <button mat-raised-button color="primary" (click)="JudgeTool(4)">Run Process</button>
        </div>
        <div class="tool mat-elevation-z10" fxLayout="row" fxLayoutAlign="space-between center">
            <div>
                <h2>Score Nominees</h2>
                <p>All of the previous plus score all nominees randomly. This is helpful to show judges how to finalize scoring.</p>
            </div>
            <button mat-raised-button color="primary" (click)="JudgeTool(5)">Run Process</button>
        </div>
        <div class="tool mat-elevation-z10" fxLayout="row" fxLayoutAlign="space-between center">
            <div>
                <h2>Finalize Judging</h2>
                <p>All of the previous plus finalize all scores. This is helpful to show district staff how to view the results of a round and handle tie-breakers.</p>
            </div>
            <button mat-raised-button color="primary" (click)="JudgeTool(6)">Run Process</button>
        </div>
    </div>
</div>